export function groupCardsByParent(
  cards: DashCardsGraphics[],
): DashCardsGraphics[] {
  const cardsCopy = cards.map((card) => ({ ...card }));
  const childrenMap: Record<string, DashCardsGraphics[]> = {};

  for (const card of cardsCopy) {
    if (card.isChildren && card.fatherId) {
      if (!childrenMap[card.fatherId]) childrenMap[card.fatherId] = [];
      childrenMap[card.fatherId].push(card);
    }
  }

  return cardsCopy
    .filter((card) => !card.isChildren)
    .map((parent) => {
      const children = childrenMap[parent.id] || [];
      if (parent.graphics && parent.graphics[0]?.type === "repeat") {
        parent.graphics[0].graphics = children;
      }
      return parent;
    });
}
